@if(src){
    <div class="relative h-full {{pClass}}">
        <img loading="lazy" [src]="src" [alt] = [alt]  [className]="class" [style]="style" (error)="detectError($event)" (load)="emitLoad()">
        <div class="dot" *ngIf="online"></div>
    </div>
}
